export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.reports', {
      url: '/reports',
      component: 'reportList',
      roles: [ 'manager', 'reporting' ]
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/reports/reports.routes.js